import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonical host: cookies + CORS are bound to REACT_APP_BACKEND_URL, so send www.* to the root domain.
try {
  const canonical = new URL(process.env.REACT_APP_BACKEND_URL);
  if (window.location.hostname === `www.${canonical.hostname}`) {
    window.location.replace(`${canonical.origin}${window.location.pathname}${window.location.search}${window.location.hash}`);
  }
} catch { /* ignore */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
